import React, { useState, useEffect } from 'react';
import { Route } from 'react-router';
import { ConfigProvider } from './contexts/ConfigContext';
import { AuthProvider } from './contexts/AuthContext';
import { useConfig } from './hooks/useConfig';
import { Layout } from './components/Layout';
import { ConsignmentLookup } from './components/ConsignmentLookUp';
import { Consignment } from './components/Consignment';
import { GoodsDetails } from './components/GoodsDetails';
import { TrackingDetails } from './components/TrackingDetails';
import { ConsignmentDocuments } from './components/ConsignmentDocuments';
import { AddConsignmentDocument } from './components/AddConsignmentDocument';
import { ConsignmentPods } from './components/ConsignmentPods';
import { ConsignmentPod } from './components/ConsignmentPod';
import { ChargingNotes } from './components/ChargingNotes';
import { ProblemForm } from './components/ProblemForm';
import { UserSettings } from './components/UserSettings';
import { handleResponse } from './utils/handlers';

import './custom.css'

export default function App(props) {

    const config = useConfig();
    const [busy, setBusy] = useState(false);
    const [authenticatedUser, setAuthenticatedUser] = useState(undefined);

    function refreshUserInfo() {
        
        fetch(`/user/info`, {
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
            })
            .then(handleResponse)
            .then(data => {
                setAuthenticatedUser(data);
            })
            .catch(error => {
                console.log(error);
            });
    }

    useEffect(() => {

        let cancel = false;
        setBusy(true);
        fetch(`/user/info`, {
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
            })
            .then(handleResponse)
            .then(data => {
                if (!cancel)
                    setAuthenticatedUser(data);
                setBusy(false);
            })
            .catch(error => {
                console.log(error);
                setBusy(false);
            });

        return () => cancel = true;
    }, []);

    return busy === true  || !authenticatedUser ? null : (
        <ConfigProvider value={config}>
            <AuthProvider value={{ authenticatedUser: authenticatedUser,refreshUserInfo: refreshUserInfo }}>
                <Layout>
                    <Route exact path='/' component={ConsignmentLookup} />
                    <Route exact path='/consignment/:consignmentId' component={Consignment} />
                    <Route path='/goods-details' component={GoodsDetails} />
                    <Route path='/tracking-details' component={TrackingDetails} />
                    <Route exact path='/consignment/:consignmentId/documents' component={ConsignmentDocuments} />
                    <Route exact path='/consignment/:consignmentId/new-document' component={AddConsignmentDocument} />
                    <Route exact path='/consignment/:consignmentId/pods' component={ConsignmentPods} />
                    <Route exact path='/consignment/:consignmentId/pods/:podId' component={ConsignmentPod} />
                    <Route exact path='/consignment/:consignmentId/charging-notes' component={ChargingNotes} />
                    <Route exact path='/consignment/:consignmentId/problem' component={ProblemForm} />
                    <Route exact path='/user/settings' component={UserSettings} />
                </Layout>
            </AuthProvider>
        </ConfigProvider>
    );
}
